import { createAction } from '@ngrx/store';

export const enum ConnectionSignActionsTypes {
  SetConnection = '[ConnectionSign] Set Connection Status',
}

export const setConnectionSignStatus = createAction(
  ConnectionSignActionsTypes.SetConnection,
  ({ isConnected }: { isConnected: boolean }) => ({
    payload: { isConnected },
  })
);
